<template>
  <div id="home">
    <TheModal v-if="showMobileModalAppDiscount" :open="showMobileModalAppDiscount" :toggleModal="toggleModalAppDiscount">
      <div class="showMobileModalAppDiscount">
        <div class="showMobileModalAppDiscount__image">
          <img src="https://ciclic.imgix.net/homes/common/ilustrations/sale-secondary.webp?auto=format&w=250&h=250" alt="" />
        </div>
        <div class="showMobileModalAppDiscount__title">
          <strong>{{ lblDiscountAPP }}</strong> no aplicativo
        </div>
        <div class="showMobileModalAppDiscount__text">
          Contrate seus Seguros e Serviços com desconto no app Ciclic
        </div>
        <div class="showMobileModalAppDiscount__button">
          <a href="https://walletinsuranceapp.page.link/downloads" class="btn">Abrir no app</a>
        </div>
        <p @click="toggleModalAppDiscount">
          Continuar no site
        </p>
      </div>
    </TheModal>
    <div class="desktopModal" v-if="showDesktopModalAppDiscount" @click="modalAppDiscountOpen = false">
      <div class="desktopModal__mask"></div>
      <div class="desktopModal__content">
        <div class="desktopModal__text">
          <div class="desktopModal__close">
            <img  src="../../assets/svg/btn-close.svg" alt />
          </div>
          <img src="https://ciclic.imgix.net/campaign/dia-consumidor-2024/devices-banner-lg.webp" alt="">
        </div>
      </div>
    </div>
    <div :class="['fundo-bg', { 'partner-bg': isPartner,  }]">
      <div :class="['wrapper', { 'partner__wrapper': isPartner }]">
        <div class="group">
          <Header v-if="appSettings.header.enable"/>
        </div>
        <div class="fundo-campaign">
          <b-col sm="12">
            <img :src="banners.mobile" alt="">
          </b-col>
          <div class="wrapper-campaign"/>
        </div>
        <b-container class="chamada-cotacao">
          <b-row>
            <b-col sm="12">
              <div :class="['alinhamento', `quotationPosition--${banners.quotationPosition}`]">
                <AcaoPromocao v-bind:isActive="true"/>
                  <div class="container-home">
                    <v-form v-model="valid" @submit.prevent="">
                      <div class="row no-gutters" v-if="!hideLead">
                        <div class="col-sm">
                          <v-text-field
                            class="inputs-home"
                            required
                            label="Nome Completo"
                            name="name"
                            autocomplete="off"
                            v-model="name"
                            :rules="[(v) => /[a-zA-ZÀ-ÿ]{2,}\s[a-zA-ZÀ-ÿ]/.test(v) || 'Por favor, digite seu nome completo']"
                          />
                        </div>
                      </div>
                      <div class="row no-gutters" v-if="!hideLead">
                        <div class="col-sm">
                          <v-text-field
                            class="inputs-home"
                            type="text"
                            required
                            name="email"
                            autocomplete="off"
                            v-model="email"
                            label="Email"
                            :rules="[(v) => isEmailValid(v) || 'Por favor, digite um email válido']"
                          />
                        </div>
                        <div class="col-sm">
                          <v-text-field
                            class="inputs-home"
                            type="text"
                            required
                            name="cell"
                            autocomplete="off"
                            v-model="cell"
                            v-mask="['(##) #####-####', '(##) ####-####']"
                            label="Telefone"
                            :rules="[(v) => v.length >= 14 || 'Por favor, digite um celular válido']"
                          />
                        </div>
                      </div>
                      <div v-if="isDeviceProject">
                        <v-select
                          v-model="typeDevice"
                          class="selectTypeDevice"
                          :label="loading ? 'Carregando...' : 'Tipo de dispositivo'"
                          :loading="loading"
                          :items="listDevicesTypes"
                          item-text="name"
                          item-value="id"
                          :disabled="listDevicesTypes.length === 0"
                          return-object
                        ></v-select>
                      </div>
                      <div class="row no-gutters">
                        <v-autocomplete
                          class="inputs-home-modelo-aparelho"
                          name="celulares"
                          attach="celulares"
                          v-model="selectedDevice"
                          :auto-select-first="true"
                          :items="listDeviceModel"
                          :disabled="listDeviceModel.length === 0"
                          item-text="name"
                          return-object
                          :label="loading ? 'Carregando...' : 'Modelo do Aparelho'"
                          :loading="loading"
                          value="Escolha o modelo do Aparelho"
                          autocomplete="off">
                          <template v-slot:no-data>
                          <div class="drop-solicitacao">
                            <p class="label-solicitacao">
                              Nenhum modelo encontrado. Deseja sugerir um aparelho?
                            </p>
                            <b-button class="botao-cadastrar-solicitacao"
                              label="Cadas"
                              v-on:click="solicitacao()">
                              <p class="titulo-botao-solicitacao">Sugerir</p>
                            </b-button>
                          </div>
                          </template>
                        </v-autocomplete>
                      </div>
                      <div class="row no-gutters">
                        <v-text-field
                          class="inputs-home-modelo-aparelhoSM"
                          name="celulares"
                          :value="selectedDevice ? selectedDevice.name : ''"
                          :label="loading ? 'Carregando...' : 'Modelo do Aparelho'"
                          :loading="loading"
                          :disabled="listDeviceModel.length === 0"
                          @click="abreModal()"
                          />
                      </div>
                      <div class="row no-gutters">
                        <v-checkbox
                          color="allowTermsUse"
                          hide-details
                          v-model="isAllowTermsUse"
                        >
                          <template v-slot:label>
                            Estou de acordo com os <a href='https://www.ciclic.com.br/termos-de-uso' target='_blank' @click.stop> Termos de Uso</a>, a <a href='https://www.ciclic.com.br/termos-de-uso#politica-de-privacidade-e-seguranca' target='_blank' @click.stop> Política de Privacidade</a> e a <a href='http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/L13709.htm' target='_blank' rel='noopener' @click.stop>Lei Geral de Proteção de Dados</a>.
                          </template>
                        </v-checkbox>
                      </div>
                      <br />
                      <div class="row no-gutters" v-if="msgError.enable">
                        <span class="msgError">{{ msgError.text }}</span>
                      </div>
                      <v-btn
                        v-else
                        id="btn-cotar-agora-portateis"
                        class="cotar-agora"
                        @click="nextPage()"
                        :disabled="hasDataInvalid"
                        label="COTAR AGORA"
                        pill
                        color="success"
                        size="lg">
                        <p class="texto-cotar">COTAR AGORA</p>
                      </v-btn>
                    </v-form>
                  </div>
              </div>
            </b-col>
          </b-row>
          <transition-group name="list">
            <div v-if="openModal" id="modalSearch" key="modalSearch">
              <div class="header">
                <div>
                  <b-button class="close-btn" variant="default" @click="abreModal()">
                    <img  src="../../assets/svg/Group@2x.svg" alt />
                  </b-button>
                </div>
                <v-text-field
                  v-model="deviceToFilter"
                  class="aparelho-search"
                  @input="filterDevice"
                  label="Modelo do aparelho"
                  autocomplete="off"
                  v-focus/>
              </div>
              <div class="body">
                <template v-if="!deviceToFilter">
                  <div class="img-busca-cel" ><img src="../../assets/img/icone-busca-cel@2x.png" alt /></div>
                  <div class="label-busca-cel"><p>Digite um modelo para <br>iniciar a pesquisa</p></div>
                </template>
                <template v-else-if="filteredDevices.length > 0">
                  <div class="item-content">
                    <div class="item" v-for="device in filteredDevices" :key="device.uuid">
                      <p @click="selectDevice(device)">{{ device.name }}</p>
                    </div>
                  </div>
                </template>
                <template v-else >
                  <div class="container-solicitacao">
                    <div class="label-busca-cel-desktop"><p>Sugira um aparelho</p></div>
                    <v-text-field
                      class="label-solicitacao"
                      required
                      label="Marca"
                      name="marca"
                      autocomplete="off"
                      maxlength="255"
                      v-model="marca"
                    />
                    <v-text-field
                      class="label-solicitacao"
                      required
                      label="Modelo"
                      name="modelo"
                      autocomplete="off"
                      maxlength="255"
                      v-model="modelo"
                    />
                    <b-button class="cadastrar-solicitacao"
                      pill
                      block
                      variant='danger'
                      @click="solicitacaoSucesso()"
                      :disabled="!this.marca || !this.modelo">
                      Sugerir
                    </b-button>
                  </div>
                </template>
              </div>
            </div>
          </transition-group>
        </b-container>
        <b-modal
          id="solicitacaoAparelho" size="lg"
          centered
          hide-footer
          body-bg-variant="white">
          <SolicitacaoAparelho
            :name="name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')"
            :email="email"
            :phone="cell"
            :typeDevice="typeDevice"
          />
        </b-modal>
        <b-modal
          id="solicitacaoAparelhoSucesso" size="lg"
          centered
          hide-footer
          body-bg-variant="white">
          <SolicitacaoAparelhoSucesso/>
        </b-modal>
      </div>
    </div>
    <StripBB v-if="appSettings.bannerBB.enable" />
    <SeguroPortateis/>
    <ProtectionSection />
    <Cobertura />
    <Vantagens />
    <ComoFunciona />
    <VideoSection />
    <FAQ v-if="isDeviceProject" />
    <FAQPhone v-else />
    <Ajuda v-if="appSettings.contact.enable" />
    <StripApp />
    <StripLogos />
    <Rodape v-if="appSettings.footer.enable" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import './Home.css'
import Header from '@/components/Header/Header'
import StripBB from '@/components/StripBB/StripBB'
import SeguroPortateis from '@/components/SeguroPortateis/SeguroPortateis'
import Vantagens from '@/components/Vantagens/Vantagens'
import ComoFunciona from '@/components/ComoFunciona/ComoFunciona'
import Cobertura from '@/components/Cobertura/Cobertura'
import FAQ from '@/components/FAQ/FAQ'
import FAQPhone from '@/components/FAQ/FAQPhone'
import Ajuda from '@/components/Ajuda/Ajuda'
import StripApp from '@/components/StripApp/StripApp'
import StripLogos from '@/components/StripLogos/StripLogos'
import Rodape from '@/components/Rodape/Rodape'
import AcaoPromocao from '@/components/AcaoPromocao/AcaoPromocao'
import SolicitacaoAparelho from '@/components/SolicitacaoAparelho/SolicitacaoAparelho'
import SolicitacaoAparelhoSucesso from '@/components/SolicitacaoAparelhoSucesso/SolicitacaoAparelhoSucesso'
import VideoSection from './_components/VideoSection'
import ProtectionSection from './_components/ProtectionSection.vue'
import { getListDeviceType, getDevices, getCampaign } from '@/api/services'
import TheModal from '@/components/ProtectedBag/partials/TheModal'

export default {
  name: 'Home',
  components: {
    Header,
    StripBB,
    SeguroPortateis,
    Vantagens,
    ComoFunciona,
    Cobertura,
    FAQ,
    FAQPhone,
    Ajuda,
    StripApp,
    StripLogos,
    Rodape,
    AcaoPromocao,
    SolicitacaoAparelho,
    VideoSection,
    SolicitacaoAparelhoSucesso,
    ProtectionSection,
    TheModal
  },
  metaInfo () {
    return {
      title: this.isDeviceProject
        ? 'Seguro Equipamentos Portáteis - Eletrônicos / Ciclic'
        : 'Seguro Celular: iPhone, Samsung e Xiaomi! Cobertura Ciclic',
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'all'
        },
        {
          vmid: 'description',
          name: 'description',
          content: this.isDeviceProject
            ? 'Seguro de Equipamentos Eletrônicos Portáteis. A Ciclic tem seguro para MacBook, seguro para iPad, seguro para iPhone, seguro para Smartwatch e muito mais!'
            : 'Seguro Celular com cobertura completa. A Ciclic tem seguro para Iphone, seguro para Samsung, seguro para Xiaomi e todas as outras marcas de smartphone.'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: this.isDeviceProject
            ? 'Seguro equipamentos eletrônicos, seguro equipamentos portáteis, seguro macbook, seguro Ipad, seguro celular'
            : 'Seguro celular, seguro para celular, seguro iphone, seguro samsung, seguro xiaomi, seguro equipamentos eletrônicos.'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.isDeviceProject
          ? 'https://produtos.ciclic.com.br/seguro-equipamentos-portateis/#/'
          : 'https://produtos.ciclic.com.br/seguro-celular/#/'
        }
      ]
    }
  },
  data () {
    return {
      selectedDevice: null,
      openModal: false,
      listDevicesTypes: [],
      listDeviceModel: [],
      listDevices: {},
      filteredDevices: [],
      name: '',
      cell: '',
      idCell: '',
      email: '',
      typeDevice: '',
      deviceToFilter: '',
      info: null,
      valid: false,
      generalConditionsUrl: '',
      leadUrl: '',
      modal: false,
      marca: '',
      modelo: '',
      isAllowTermsUse: false,
      isMobile: false,
      modalAppDiscountOpen: true,
      loading: false,
      hideLead: false,
      msgError: {
        enable: false,
        text: 'Ops, ocorreu um erro! Tente novamente mais tarde.'
      },
      promoCode: '',
      lblDiscountAPP: '15% OFF',
      campaign: {},
      isPartner: false,
      bannersList: {
        ciclic: {
          desktop: 'url(https://ciclic.imgix.net/devices/home-banner/default-28-12-2023/ciclic-seguro-celular-portateis-desktop.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/home-banner/default-28-12-2023/ciclic-seguro-celular-portateis-mobile.webp?auto=format,compress',
          quotationPosition: 'left'
        },
        livelo: {
          desktop: 'url(https://ciclic.imgix.net/devices/livelo/banner-livelo-default-desktop.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/livelo/banner-livelo-default-mobile.webp?auto=format,compress',
          quotationPosition: 'right'
        },
        dotz: {
          desktop: 'url(https://ciclic.imgix.net/devices/dotz/banner-dotz-portateis-desktop.jpg?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/dotz/banner-dotz-portateis-mobile.jpg?auto=format,compress',
          quotationPosition: 'right'
        },
        'surf-telecom': {
          desktop: 'url(https://ciclic.imgix.net/cellphone/surftelecom/banner-surftelecom-desktop.jpg?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/cellphone/surftelecom/banner-surftelecom-mobile.jpg?auto=format,compress',
          quotationPosition: 'right'
        },
        tpmbank: {
          desktop: 'url(https://ciclic.imgix.net/devices/tpmbank/tpmbank_desktop_banner.png?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/tpmbank/tpmbank_mobile_banner.jpg?auto=format,compress',
          quotationPosition: 'right'
        },
        mrv: {
          desktop: 'url(https://ciclic.imgix.net/devices/mrv/banner-mrv-desk.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/mrv/banner-mrv-mobile.webp?auto=format,compress',
          quotationPosition: 'left'
        },
        jurosbaixos: {
          desktop: 'url(https://ciclic.imgix.net/devices/juros-baixos/banner-desk.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/juros-baixos/banner-mobile.webp?auto=format,compress',
          quotationPosition: 'left'
        },
        cgd: {
          desktop: 'url(https://ciclic.imgix.net/devices/cgd/banner-desk.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/cgd/banner-mobile.webp?auto=format,compress',
          quotationPosition: 'right'
        },
        'multivoce-green': {
          desktop: 'url(https://ciclic.imgix.net/devices/multivoce/banner-green-desk.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/multivoce/banner-green-mobile.webp?auto=format,compress',
          quotationPosition: 'right'
        },
        'multivoce-silver': {
          desktop: 'url(https://ciclic.imgix.net/devices/multivoce/banner-silver-desk.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/multivoce/banner-silver-mobile.webp?auto=format,compress',
          quotationPosition: 'right'
        },
        'multivoce-gold': {
          desktop: 'url(https://ciclic.imgix.net/devices/multivoce/banner-gold-desk.webp?auto=format,compress)',
          mobile: 'https://ciclic.imgix.net/devices/multivoce/banner-gold-mobile.webp?auto=format,compress',
          quotationPosition: 'right'
        }
      },
      banners: {}
    }
  },
  async mounted () {
    this.isMobile = window.screen.width < 768
    this.hideLead = this.$route.meta && this.$route.meta.hideLead
    this.loading = true
    this.clearSession()
    this.setBanners()
    this.applyPromoCode()

    if (!this.isDeviceProject) {
      this.typeDevice = {
        id: 1,
        name: 'Celular'
      }
    }

    this.leadUrl = `${process.env.VUE_APP_API_URL}/internal-commons/v2/lead`
    this.generalConditionsUrl = process.env.VUE_APP_CHICO_XAVIER

    this.loadHomePage()

    await getListDeviceType()
      .then(res => {
        if (res.status !== 200 || res.data.length === 0) {
          this.$sentry.logWithContext({
            ctx: { step: '[loadHomePage]: response veio com status diferente de 200 ou vazio', data: res },
            error: new Error('[loadHomePage]: response veio com status diferente de 200 ou vazio')
          })
          this.msgError.enable = true
        }

        this.listDevicesTypes = res.data
        this.loading = false
      })
      .catch(error => {
        this.$sentry.logWithContext({
          ctx: { step: '[loadHomePage]' }, error
        })
        this.msgError.enable = true
        this.loading = false
      })
  },
  watch: {
    async typeDevice ({ name, id }) {
      this.listDeviceModel = []
      this.selectedDevice = null

      if (!this.listDevices[name]) {
        this.loading = true

        await getDevices(id)
          .then(res => {
            if (res.status !== 200 || res.data.length === 0) {
              this.$sentry.logWithContext({
                ctx: { step: '[getDevices]: response veio com status diferente de 200 ou vazio', data: res },
                error: new Error('[getDevices]: response veio com status diferente de 200 ou vazio')
              })
              this.showMsgError()
            }

            this.listDevices[name] = res.data
          })
          .catch(error => {
            this.$sentry.logWithContext({
              ctx: { step: '[getDevices]' }, error
            })
            this.showMsgError()
          })
      }

      this.listDeviceModel = this.listDevices[name] || []
      this.loading = false
    }
  },
  directives: {
    focus: {
      inserted (el) {
        setTimeout(() => el.querySelector('input').focus(), 200)
      }
    }
  },
  computed: {
    ...mapState(['appSettings']),
    ...mapState(['lead', 'params']),
    hasDataInvalid () {
      return !this.isAllowTermsUse || !this.selectedDevice || !this.valid
    },
    isDeviceProject () {
      return process.env.VUE_APP_PRODUCT_NAME === 'seguro-equipamentos-portateis'
    },
    showMobileModalAppDiscount () {
      if (this.isMobile && this.modalAppDiscountOpen && !this.appSettings.partner) {
        return true
      }
      return false
    },
    showDesktopModalAppDiscount () {
      if (!this.isMobile && this.modalAppDiscountOpen && !this.appSettings.partner) {
        return false
      }
      return false
    }
  },
  methods: {
    ...mapActions(['actionPostLead']),
    showMsgError () {
      this.msgError.enable = true
      setTimeout(() => {
        this.msgError.enable = false
      }, 5000)
    },
    abreModal () {
      this.openModal = !this.openModal
    },
    filterDevice () {
      const search = this.deviceToFilter.trim().toLowerCase()

      this.filteredDevices = this.listDeviceModel
        .filter((item) => {
          if (~item.name.toLowerCase().search(search)) {
            return item
          }
        }, [])
    },
    selectDevice (device) {
      this.selectedDevice = device
      this.abreModal()
    },
    applyPromoCode () {
      let { promoCode } = this.$route.query || this.params

        if (promoCode === undefined && !this.appSettings.partner) {
          const currentDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
          const consumerDay = currentDate.isBetween('2024-05-13 08:00:00', '2024-05-17 23:59:59', 'seconds', true)

          if (consumerDay) {
            this.lblDiscountAPP = '20% OFF'
            promoCode = 'MAE2024'
          }
        }

        this.promoCode = promoCode
    },
    nextPage () {
      if (!this.hasDataInvalid && this.selectedDevice) {
        window.dataLayer.push({
          event: 'dispositivos-ciclic',
          categoria: 'dispositivos-cotacao',
          acao: 'click',
          rotulo: this.typeDevice.name
        })
        if (!this.hideLead) this.createLead()

        this.$router.push({
          path: 'contratacao',
          query: {
            id: this.selectedDevice.uuid,
            ...(this.promoCode && {
              promoCode: this.promoCode
            })
          }
        })
      }
    },
    solicitacao () {
      this.$bvModal.show('solicitacaoAparelho')
    },
    solicitacaoSucesso () {
      let payload = {
        product: 'CELULAR',
        item: {
          manufacturer: this.marca,
          model: this.modelo
        }
      }
      if (this.name) {
        payload.item.name = this.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      }
      if (this.email) {
        payload.item.email = this.email
      }
      if (this.phone) {
        payload.item.phone = this.phone
      }
      if (this.typeDevice) {
        payload.item.typeDevice = this.typeDevice
      }
      axios
        .post(`${process.env.VUE_APP_API_URL}/internal-cell-phones/v1/intentions`, payload, JSON.parse(sessionStorage.config))
          .then(() => {
            this.$bvModal.show('solicitacaoAparelhoSucesso')
            this.openModal = false
          })
          .catch(error => {
            this.$sentry.logWithContext({
              ctx: { step: '[solicitacaoSucesso]' }, error
            })
          })
    },
    isEmailValid (email) {
      let regex = /^[\w.-]+@[a-zA-Z]+?\.[a-zA-Z]{2,3}\.{0,1}[a-zA-Z]{1,2}$/
      return regex.test(email)
    },
    async createLead () {
      if (this.isAllowTermsUse && !this.lead.uuid) {
        const itemName = this.selectedDevice.name.split(' - ')
        const _queryString = location.href.match(/\?(.*)/) || ''
        const _params = _queryString && `&${_queryString[1]}`

        const lead = {
          allowTermsUse: this.isAllowTermsUse,
          itemUuid: this.selectedDevice.uuid,
          leadEmail: this.email.trim(),
          leadManufacturer: itemName[0],
          leadModel: itemName[1],
          leadName: this.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(),
          leadPhone: this.cell,
          utmCampaign: this.params.utm_campaign,
          utmMedium: this.params.utm_medium,
          utmSource: this.params.utm_source,
          link: `${process.env.VUE_APP_HOME_URL}#/contratacao?id=${this.selectedDevice.uuid}${_params}`,
          step: this.$route.name,
          type: this.isDeviceProject ? 'DEVICES' : 'CELLPHONE'
        }

        await this.actionPostLead(lead)
      }

      sessionStorage.setItem('user', JSON.stringify({
        name: this.name.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim(),
        email: this.email.trim(),
        cell: this.cell
      }))
    },
    clearSession () {
      sessionStorage.removeItem('user')
      sessionStorage.removeItem('ciclic:checkout')
      sessionStorage.removeItem('promoCode')
      sessionStorage.removeItem('device')
      sessionStorage.removeItem('ciclic:product')
    },
    loadHomePage () {
      window.dataLayer.push({
        event: 'affiliationTag',
        level: 'categoryPage',
        categoryName: 'dispositivos'
      })
    },
    toggleModalAppDiscount () {
      this.modalAppDiscountOpen = !this.modalAppDiscountOpen
    },
    async setBanners () {
      try {
        if (this.appSettings.partner) {
          this.isPartner = true

          if (this.appSettings.partner.slug === 'livelo') {
            this.banners.quotationPosition = this.bannersList.livelo.quotationPosition

            const { data } = await getCampaign()
            this.campaign = data

            if (this.campaign.imagePath) {
              this.banners = {
                ...(this.bannersList.livelo),
                desktop: `url('${this.campaign.imagePath[0]}')`,
                mobile: this.campaign.imagePath[1]
              }
              return
            }
          }

          this.banners = this.bannersList[this.appSettings.partner.slug]
          return
        }

        this.banners = this.bannersList.ciclic
      } catch (error) {
        console.error(error)
        this.banners = this.bannersList.ciclic
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.disclaimer {
  padding: 32px;
}
.list-item {
  display: inline-block;
  margin-right: 10px;
}

.list-enter-active, .list-leave-active {
  transition: all 350ms;
}

.list-enter, .list-leave-to {
  opacity: 0;
  transform: translateY(500px);
}

.fundo-bg{
  background-size: cover;
  background-position: center;
}
.banner-livelo-mobile{
  max-width: 100%;
}

@media(max-width: 1264px) {
  .fundo-bg .col-sm-12 {
    padding: 0;
  }

  .fundo-bg img {
    width: 100%;
  }
}

@media(min-width: 1265px){
  .fundo-bg .wrapper{
    background-image: v-bind('banners.desktop') !important;
    background-position: center center !important;
    background-size: cover !important;
  }
}
.partner__wrapper .fundo-campaign{
  height: auto !important;
}

.partner__wrapper .wrapper-campaign{
  display: none;
}

.partner__wrapper{
  background: none !important;
}
.partner__wrapper .alinhamento.quotationPosition--right{
  margin-left: auto;
}

.showMobileModalAppDiscount{
  background: linear-gradient(192deg, #FFF 0%, #D9F7F5 100%);
  color: var(--neutral-70, #373739);
  font-family: Nunito, sans-serif;
  font-size: 18px;
  padding-bottom: 40px;
  text-align: center;
  &__image{
    margin-bottom: 24px;
  }
  &__title{
    font-family: Oscine, sans-serif;
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 8px;
    padding: 0 15px;
    strong{
      color: var(--primary-light-70, #5AD93A);
      font-weight: 700;
    }
  }
  &__text{
    font-size: 16px;
    margin: 0 auto 24px auto;
    max-width: 300px;
  }
  &__button{
    margin-bottom: 6px;
    .btn{
      background: var(--primary-light-40, #72F951);
      border-radius: 28px;
      color: var(--neutral-70, #373739);
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      margin-bottom: 16px;
      padding: 12px 32px;
    }
  }
}

.desktopModal{
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  text-align: center;
  top: 0;
  width: 100%;
  z-index: 1;
  &__mask{
    background: rgba(0,0,0,0.75);
    height: 100%;
    position: absolute;
    width: 100%;
  }
  &__content{
    background: transparent;
    border-radius: 24px;
    max-width: 860px;
    padding: 24px 42px 42px;
    position: relative;
    width: 80%;
    @media(min-width: 1024px){
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding-bottom: 56px;
    }
  }
  &__close{
    position: absolute;
    text-align: right;
    top: 15px;
    right: 15px;
    @media(min-width: 1024px){
      margin-bottom: 42px;
      width: 100%;
    }
  }
  &__text{
    position: relative;
      &__intro{
        align-items: center;
        color: var(--Neutral-50, #76767A);
        display: flex;
        font-family: Nunito, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        justify-content: center;
        img{
          margin: 0 8px;
        }
        @media(min-width: 1024px){
          font-size: 14px;
          justify-content: flex-start;
        }
      }
      &__title{
        color: var(--Neutral-70, #373739);
        font-family: Oscine, sans-serif;
        font-size: 40px;
        font-style: normal;
        font-weight: 400;
        line-height: 48px;
        span{
          color: var(--Primary-Light-70, #5AD93A);
          font-weight: 700;
        }
        @media(min-width: 1024px){
          font-size: 50px;
        }
      }
      &__copy{
        color: var(--Neutral-60, #535355);
        font-family: Nunito, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        @media(min-width: 1024px){
          font-size: 18px;
        }
      }
      @media(min-width: 1024px){
        margin-bottom: 24px;
      }
  }
  &__image{
    img{
      max-width: 100%;
    }
    @media(min-width: 1024px){
        text-align: right;
        width: 35%;
      }
  }
  @media(min-width: 1024px){
    text-align: left;
  }
}
</style>
